import React, { useState } from 'react';
import '../styles/EncuestasPage.css';

const URL_ENCUESTA_PADRES = 'https://forms.gle/JskMZ4NG3ddh8D9Y7';
const URL_ENCUESTA_ESTUDIANTES = 'https://forms.gle/U3mF7u5AVsk6Gpex6';
const URL_ENCUESTA_DOCENTES = 'https://forms.gle/bL4dJ7mrTPf5PsyZ7';
const PASSWORD_DOCENTES = 'guerrero20';

const EncuestasPage = () => {
  const [errorDocentes, setErrorDocentes] = useState('');
  const [encuestaActiva, setEncuestaActiva] = useState(null); // 'padres' | 'estudiantes' | 'docentes' | null
  const [modalDocentesAbierto, setModalDocentesAbierto] = useState(false);
  const [passwordDocentes, setPasswordDocentes] = useState('');

  const abrirEncuesta = (tipo) => {
    setErrorDocentes('');
    setEncuestaActiva(tipo);
  };

  const cerrarEncuesta = () => {
    setEncuestaActiva(null);
  };

  const abrirModalDocentes = () => {
    setPasswordDocentes('');
    setErrorDocentes('');
    setModalDocentesAbierto(true);
  };

  const cerrarModalDocentes = () => {
    setModalDocentesAbierto(false);
    setPasswordDocentes('');
    setErrorDocentes('');
  };

  const handleAccesoDocentes = (e) => {
    e.preventDefault();
    if (passwordDocentes === PASSWORD_DOCENTES) {
      setModalDocentesAbierto(false);
      setPasswordDocentes('');
      abrirEncuesta('docentes');
    } else {
      setErrorDocentes('Contraseña incorrecta. Intente nuevamente.');
    }
  };

  const urlEncuestaActiva = {
    padres: URL_ENCUESTA_PADRES,
    estudiantes: URL_ENCUESTA_ESTUDIANTES,
    docentes: URL_ENCUESTA_DOCENTES,
  }[encuestaActiva];

  const tituloEncuestaActiva = {
    padres: 'Encuesta para padres de familia',
    estudiantes: 'Encuesta para estudiantes',
    docentes: 'Encuesta para docentes',
  }[encuestaActiva];

  return (
    <div className="encuestas-container">
      <h1 className="encuestas-title">Encuestas</h1>

      {!encuestaActiva && (
        <>
      <div className="encuestas-botones">
        <button
          type="button"
          onClick={() => abrirEncuesta('padres')}
          className="encuestas-boton encuestas-boton-padres"
        >
          Encuestas para padres de familia
        </button>
        <button
          type="button"
          onClick={() => abrirEncuesta('estudiantes')}
          className="encuestas-boton encuestas-boton-estudiantes"
        >
          Encuestas para estudiantes
        </button>
      </div>

      <div className="encuestas-texto">
        <p>Estimadas madres, padres de familia, tutores y estudiantes.</p>
        <p>
          Con el propósito de conocer sus opiniones, experiencias y propuestas, les invitamos a
          participar en las encuestas correspondientes a nuestra comunidad escolar.
        </p>
        <p>Para responder, seleccionen el botón que corresponda:</p>

        <p>
          <strong>ENCUESTAS PARA PADRES DE FAMILIA</strong>
          <br />
          Dirigida exclusivamente a madres, padres o tutores.
        </p>

        <p>
          <strong>ENCUESTAS PARA ESTUDIANTES</strong>
          <br />
          Dirigida exclusivamente a las alumnas y alumnos.
        </p>

        <p>
          <strong>ENCUESTAS PARA DOCENTES</strong>
          <br />
          Dirigida exclusivamente a las y los docentes de la institución.
        </p>

        <p>
          Su participación es muy importante, ya que sus respuestas nos permitirán identificar
          áreas de oportunidad y continuar mejorando las actividades, servicios y procesos de
          nuestra escuela.
        </p>

        <p>Les solicitamos responder la encuesta que les corresponde con sinceridad y responsabilidad.</p>

        <p>
          <strong>Gracias por participar y contribuir a la mejora de nuestra comunidad escolar.</strong>
        </p>
      </div>

      <div className="encuestas-docentes">
        <button
          type="button"
          onClick={abrirModalDocentes}
          className="encuestas-boton encuestas-boton-docentes"
        >
          Encuesta para docentes
        </button>
      </div>
        </>
      )}

      {encuestaActiva && (
        <div className="encuestas-iframe-wrapper">
          <div className="encuestas-iframe-header">
            <h2>{tituloEncuestaActiva}</h2>
            <button
              type="button"
              onClick={cerrarEncuesta}
              className="encuestas-cerrar"
            >
              Regresar
            </button>
          </div>
          <iframe
            title={tituloEncuestaActiva}
            src={urlEncuestaActiva}
            className="encuestas-iframe"
          >
            Cargando…
          </iframe>
        </div>
      )}

      {modalDocentesAbierto && (
        <div className="encuestas-modal-overlay" onClick={cerrarModalDocentes}>
          <div className="encuestas-modal" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              onClick={cerrarModalDocentes}
              className="encuestas-modal-cerrar"
              aria-label="Cerrar"
            >
              ✕
            </button>
            <h2 className="encuestas-modal-titulo">Acceso para docentes</h2>
            <p className="encuestas-modal-texto">
              Ingrese la contraseña para acceder a la encuesta de docentes.
            </p>
            <form onSubmit={handleAccesoDocentes} className="encuestas-modal-form">
              <input
                type="password"
                value={passwordDocentes}
                onChange={(e) => setPasswordDocentes(e.target.value)}
                placeholder="Contraseña"
                className="encuestas-modal-input"
                autoFocus
              />
              {errorDocentes && <p className="encuestas-error">{errorDocentes}</p>}
              <div className="encuestas-modal-botones">
                <button type="button" onClick={cerrarModalDocentes} className="encuestas-modal-cancelar">
                  Cancelar
                </button>
                <button type="submit" className="encuestas-modal-entrar">
                  Entrar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default EncuestasPage;
